<template>
  <section class="md:px-14 my-10 flex flex-col justify-start w-full">
    <form
      @submit.prevent="submitPassword()"
      class="grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md"
    >
      <div class="col-span-12">
        <div class="flex justify-between items-center">
          <h6>
            {{
              $t("labels.generic", {
                pt: "Alterar senha",
                en: "Change password",
              })
            }}
          </h6>
          <Button
            type="submit"
            label="Salvar"
            class="btn-primary p-button-sm"
            :loading="loading"
          />
        </div>
      </div>
      <div class="col-span-12 grid grid-cols-12 gap-5 items-center">
        <div class="col-span-12 md:col-span-6 flex flex-col">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Senha atual",
                en: "Actual password",
              })
            }}
          </p>

          <InputPassword
            id="password-input"
            v-model="form.currentPassword"
            :feedback="false"
            toggleMask
            :class="v$.form.currentPassword.$error ? 'p-invalid' : ''"
          />
          <Errors :errors="v$.form.currentPassword.$errors" />
        </div>
        <div class="col-span-12 md:col-span-6 flex items-center gap-3 mt-5">
          <v-icon
            name="hi-information-circle"
            :scale="2"
            class="text-gray-400"
          />
          <p class="text-gray-400 text-sm w-72">
            {{
              $t("labels.generic", {
                pt: "Por questões de segurança, é necessário inserir a sua senha atual",
                en: "For security reasons, you must enter your current password",
              })
            }}
          </p>
        </div>
      </div>
      <div class="col-span-12 grid grid-cols-12 gap-3">
        <div class="col-span-12 md:col-span-6 flex flex-col">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Nova senha",
                en: "New password",
              })
            }}
          </p>

          <InputPassword
            id="password-input"
            v-model="form.password"
            :feedback="false"
            toggleMask
            :class="v$.form.password.$error ? 'p-invalid' : ''"
          />
          <Errors :errors="v$.form.password.$errors" />
        </div>
        <div class="col-span-12 md:col-span-6 flex flex-col">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Confirmar nova senha",
                en: "Confirm new password",
              })
            }}
          </p>

          <InputPassword
            id="password-input"
            v-model="form.confirmPassword"
            :feedback="false"
            toggleMask
            :class="v$.form.confirmPassword.$error ? 'p-invalid' : ''"
          />
          <Errors :errors="v$.form.confirmPassword.$errors" />
        </div>
      </div>
    </form>
  </section>
</template>

<script lang="ts">
import { minLength, required, sameAs } from "@/locale/locale.config";
import { UsersRest } from "@/services/rest/users.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import useVuelidate from "@vuelidate/core";
import { delay } from "rxjs";
import { defineComponent } from "vue";

export default defineComponent({
  name: "editPassword",
  computed: {
    rest(): UsersRest {
      return new UsersRest();
    },
  },
  data() {
    return {
      form: {} as any,
      loading: false as boolean,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      form: {
        currentPassword: { required },
        password: { required, min: minLength(3) },
        confirmPassword: {
          sameAs: sameAs(this.form.password),
        },
      },
    };
  },
  methods: {
    submitPassword(): void {
      this.v$.form.$touch();
      if (!this.v$.form.$error) {
        this.loading = true;
        const data = {
          currentPassword: this.form.currentPassword,
          password: this.form.password,
        };
        this.rest
          .updatePassword(data)
          .pipe(delay(1000))
          .subscribe({
            next: () => {
              this.$toast.add(
                ToastFactory.success(Messages.PASSWORD_EDIT_SUCCESS)
              );
              this.v$.form.$reset();
              this.form = new Object();
              this.loading = false;
            },
            error: () => {
              this.loading = false;
            },
          });
      }
    },
  },
});
</script>
